import { Config } from '@comall-backend-builder/core/lib/parser';

export let config: Config = {
    components: {
        filterWordView: {
            component: 'Card',
            content: { component: 'Iframe', href: '/4008/filterWord/show' },
        },
        reviewView: {
            component: 'Card',
            content: { component: 'Iframe', href: '/4007/reviewAudit/show' },
        },
        memberView: {
            component: 'Card',
            content: { component: 'Iframe', href: '/4001/member/show' },
        },

        reasonView: {
            component: 'Card',
            content: { component: 'Iframe', href: '/4005/reason/show' },
        },

        articleCategroyView: {
            component: 'Card',
            content: { component: 'Iframe', href: '/9002/articlecategory/show' },
        },

        articleView: {
            component: 'Card',
            content: { component: 'Iframe', href: '/9003/article/show' },
        },

        securityUserView: {
            component: 'Card',
            content: { component: 'Iframe', href: '/10008/securityUser/show' },
        },

        securityView: {
            component: 'Card',
            content: { component: 'Iframe', href: '/10009/security/show' },
        },

        expressView: {
            component: 'Card',
            content: { component: 'Iframe', href: '/21000020/express/config/show' },
        },

        smsView: {
            component: 'Card',
            content: { component: 'Iframe', href: '/10005/sms/show' },
        },

        regionView: {
            component: 'Card',
            content: { component: 'Iframe', href: '/10006/region/show' },
        },

        deliveryView: {
            component: 'Card',
            content: { component: 'Iframe', href: '/9006/delivery/show' },
        },

        paymentContentView: {
            component: 'Card',
            content: { component: 'Iframe', href: '/5007/paymentMode/showContent' },
        },

        paymentModeView: {
            component: 'Card',
            content: { component: 'Iframe', href: '/10003/paymentMode/show' },
        },

        noticeTemplateView: {
            component: 'Card',
            content: { component: 'Iframe', href: '/9004/template/show' },
        },

        orderView: {
            component: 'Card',
            content: { component: 'Iframe', href: '/8001/order/show' },
        },

        aftersaleView: {
            component: 'Card',
            content: { component: 'Iframe', href: '/8002/afterSalesApply/show' },
        },
        refundView: {
            component: 'Card',
            content: { component: 'Iframe', href: '/8003/refund/show' },
        },
        pointsOrderView: {
            component: 'Card',
            content: { component: 'Iframe', href: '/8004/points_order/show' },
        },
        structureView: {
            component: 'Card',
            content: { component: 'Iframe', href: '/5006/surfaceSection/showhome/1' },
        },
        hotWordsView: {
            component: 'Card',
            content: { component: 'Iframe', href: '/92/hot_words/show' },
        },

        productBrandView: {
            component: 'Card',
            content: { component: 'Iframe', href: '/3003/brand/show' },
        },

        storeView: {
            component: 'Card',
            content: { component: 'Iframe', href: '/11001/store/show' },
        },

        feedbackView: {
            component: 'Card',
            content: { component: 'Iframe', href: '/4002/feedback/show' },
        },

        appointmentView: {
            component: 'Card',
            content: { component: 'Iframe', href: '/8005/appointment/show' },
        }
    },
    routes: [
        {
            path: '/',
            component: 'MenuSideNav',
            childRoutes: [
                {
                    path: '/dashboard',
                    component: 'Dashboard',
                    breadcrumbName: 'Dashboard',
                    isIndex: true,
                },
                {
                    path: '/trade',
                    breadcrumbName: '交易管理',
                    component: 'Viewport',
                    childRoutes: [
                        {
                            path: '/order',
                            breadcrumbName: '销售订单管理',
                            component: 'orderView',
                        },
                        {
                            path: '/aftersale',
                            breadcrumbName: '售后管理',
                            component: 'aftersaleView',
                        },
                        {
                            path: '/refund',
                            breadcrumbName: '退款管理',
                            component: 'refundView',
                        },
                        {
                            path: '/pointsOrder',
                            breadcrumbName: '积分订单管理',
                            component: 'pointsOrderView',
                        },
                        {
                            path: '/appointment',
                            breadcrumbName: '预约看货记录',
                            component: 'appointmentView',
                        },
                    ],
                },

                {
                    path: '/user',
                    breadcrumbName: '用户管理',
                    component: 'Viewport',
                    childRoutes: [
                        {
                            path: '/member',
                            component: 'memberView',
                            breadcrumbName: '会员管理',
                        },
                        {
                            path: '/feedback',
                            component: 'feedbackView',
                            breadcrumbName: '意见反馈',
                        },
                        {
                            path: '/review',
                            component: 'reviewView',
                            breadcrumbName: '会员评论管理',
                        },
                        {
                            path: '/filterWord',
                            component: 'filterWordView',
                            breadcrumbName: '敏感词管理',
                        },
                    ],
                },
                {
                    path: '/content',
                    breadcrumbName: '内容管理',
                    component: 'Viewport',
                    childRoutes: [
                        {
                            path: '/reason',
                            component: 'reasonView',
                            breadcrumbName: '原因管理',
                        },
                        {
                            path: '/articleCategroy',
                            component: 'articleCategroyView',
                            breadcrumbName: '文章栏目管理',
                        },
                        {
                            path: '/article',
                            component: 'articleView',
                            breadcrumbName: '文章管理',
                        },
                    ],
                },
                {
                    path: '/system',
                    breadcrumbName: '系统管理',
                    component: 'Viewport',
                    childRoutes: [
                        {
                            path: '/securityUser',
                            component: 'securityUserView',
                            breadcrumbName: '系统用户管理',
                        },
                        {
                            path: '/security',
                            component: 'securityView',
                            breadcrumbName: '权限设置',
                        },
                        {
                            path: '/express',
                            component: 'expressView',
                            breadcrumbName: '顺丰快递配置',
                        },
                        {
                            path: '/sms',
                            component: 'smsView',
                            breadcrumbName: '短信配置',
                        },
                        {
                            path: '/region',
                            component: 'regionView',
                            breadcrumbName: '地区管理',
                        },
                        {
                            path: '/delivery',
                            component: 'deliveryView',
                            breadcrumbName: '收购配送管理',
                        },
                        {
                            path: '/paymentContent',
                            component: 'paymentContentView',
                            breadcrumbName: '支付方式内容管理',
                        },
                        {
                            path: '/paymentMode',
                            component: 'paymentModeView',
                            breadcrumbName: '支付方式管理',
                        },
                        // {
                        //     path: '/noticeTemplate',
                        //     component: 'noticeTemplateView',
                        //     breadcrumbName: '站内信模板配置',
                        // },
                    ],
                },
                {
                    path: '/store',
                    breadcrumbName: '门店管理',
                    component: 'Viewport',
                    childRoutes: [
                        {
                            path: '/stores',
                            component: 'storeView',
                            breadcrumbName: '门店信息管理',
                        },
                    ],
                },
            ],
        },
    ],
};
